import { Component, OnInit } from '@angular/core';
import { DataService } from './shared/network/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  time = '0:00';
  
  constructor(private dataService: DataService){}

  ngOnInit(): void {
    /*this.dataService.get('Home/Test').then((r:any) => {
      this.time = r.time;
    });*/
  }
}
